import React, { useEffect } from "react";
import History from "./History/History.jsx";
import Transfer from "./Transfer/Transfer.jsx";
import {
  useGetMainQuery,
} from "services/clientApi";
import { useNavigate } from "react-router-dom";

const BitcoinCmp = ({ isHistory, setIsHistory }) => {
  const navigate = useNavigate();
  const { data: main, isLoading: loading, isError: error, refetch } = useGetMainQuery();
  const logOut = () => {
    localStorage.removeItem("isClient");
    localStorage.removeItem("auth_client");
    navigate("/login");
    window.location.reload();
  };

  if (error) {
    logOut()
  }

  useEffect(() => {
    refetch();
    const interval = setInterval(() => {
      refetch();
    }, 60000);

    return () => clearInterval(interval);
  }, [refetch]);

  return (
    <div>
      <div className="d-flex justify-content-between  w-80 m-auto mt-5"></div>
      <div className="mt-5 m-2 ">
        {isHistory ? (
          <History setIsHistory={setIsHistory} />
        ) : (
          <Transfer setIsHistory={setIsHistory} />
        )}
      </div>
    </div>
  );
};

export default BitcoinCmp;
